export default "/images/booked-flag.png?07a21bc042ed46f4177689a8b564c7c1";